export default __webpack_public_path__ + "static/media/789.88e51940.png";